module.exports = __webpack_public_path__ + "media/images/logo-329274045cf684d18fe084d2f23d1e02.png";